import React from 'react';
import { useInView } from '../../hooks/useReveal';

/** Scroll-triggered fade/slide-up wrapper. */
function Reveal({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      className={`fx-reveal${inView ? ' is-visible' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
